import React from 'react'
import { Box, Heading } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  box: {
    borderLeft: `5px solid`,
    borderLeftColor: `omegaLighter`,
    pl: 5,
    py: 2,
    my: 5
  },
  quote: {
    color: `omegaDark`,
    fontWeight: `body`
  },
  writer: {
    color: `omegaDark`,
    mb: 0
  }
}

const HeroRight = () => (
  <Box sx={styles.box}>
    <Heading variant='h3' sx={styles.quote}>
      “If you think you know-it-all about cybersecurity, this discipline was probably ill-explained to you.”
    </Heading>
    <Heading variant='h4' sx={styles.writer}>
    Stephane Nappo
    </Heading>
  </Box>
)

export default HeroRight

